// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"25cad56a","62":"cfcbd5e8","375":"3db20547","400":"3f9da68d","408":"db3ec13c","695":"14340118","696":"334d1fd2","720":"3cc451ef","835":"360ab462","928":"cbc71e76","960":"cc44902b"}[chunkId] + ".chunk.js";
};